import Relay from 'react-relay';

interface CreateBulkInvitationMutationProps {
    currentOrganisationId: string;
    email: string;
    organisationIds: string[];
    role: string;
}

export default class CreateBulkInvitationMutation extends Relay.Mutation<CreateBulkInvitationMutationProps> {
    getMutation() {
        return Relay.QL`mutation {createBulkInvitation}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on CreateBulkInvitationPayload {
                email,
                emailSent,
                emailError,
                userFound,
                invitationId,
                results {
                    organisationId,
                    organisationName,
                    status,
                    error
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            currentOrganisationId: this.props.currentOrganisationId,
            email: this.props.email,
            organisationIds: this.props.organisationIds,
            role: this.props.role,
        };
    }
}
